import axios from '@/core/axios';

import { CustomerPayment, PaymentMethodOption } from './customer-payments.types';

export class CustomerPaymentsService {
  listMethods(): Promise<PaymentMethodOption[]> {
    return axios.get<PaymentMethodOption[]>('/payments/methods').then(resp => resp?.data || []);
  }

  listForCustomer(customerId: number | string): Promise<CustomerPayment[]> {
    return axios.get<CustomerPayment[]>(`/customers/${customerId}/payments`).then(resp => resp?.data || []);
  }

  get(paymentId: number | string): Promise<CustomerPayment> {
    return axios.get<CustomerPayment>(`/payments/${paymentId}`).then(resp => resp?.data);
  }

  create(customerId: number | string, payment: Partial<CustomerPayment>): Promise<CustomerPayment> {
    return axios
      .post<CustomerPayment>(`/customers/${customerId}/payments`, { customer_payment: payment })
      .then(resp => resp?.data);
  }

  update(paymentId: number | string, payment: Partial<CustomerPayment>): Promise<CustomerPayment> {
    if (!paymentId) throw new Error('Missing payment id in update');
    return axios.put<CustomerPayment>(`/payments/${paymentId}`, { customer_payment: payment }).then(resp => resp?.data);
  }
}

export const customerPaymentsService = new CustomerPaymentsService();
